<template>
  <modal-template
    ref="modal"
    size="lg"
    title="Atribuir o orçamento"
    type-modal="assign_quotation_modal"
  >
    <div class="modal-content__main">
      <d-form>

        <d-form-row>
          <!-- Message -->
          <d-col md="12" class="form-group">
            <label>Funcionário</label>
            <autocomplete
              ref="autocomplete"
              placeholder="Funcionario"
              :items="users"
              item-show="name"
              :on-input="onInput"
              :on-select="setUser"
              :on-show-text="showText"
            ></autocomplete>
          </d-col>
        </d-form-row>

        <d-form-row>
          <!-- Message -->
          <d-col md="12" class="form-group mb-0">
            <label>Mensagem</label>
            <editor ref="recibo" :model.sync="model.comment"/>
          </d-col>
        </d-form-row>

      </d-form>
    </div>

    <div slot="actions" class="modal-content__control" >
      <d-button
        type="button"
        @click="send()"
        class="btn btn-sm btn-primary"
      >Enviar</d-button>
    </div>
  </modal-template>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import Editor from '_shared/Editor.vue';
import Autocomplete from '_shared/Autocomplete.vue';
import ModalTemplate from '_shared/Modal.vue';
import QuotationService from '_services/rest/modules/quotation';
import { _OPEN_ASSIGN_MODAL_ } from '../QuotationModel';

const MODEL = {
  comment: '',
  assign_to: '',
};

export default {
  name: 'assign-modal',
  props: {
  },
  data() {
    return {
      loading: false,
      model: { ...MODEL },
      quotation: null,
    };
  },
  components: {
    Editor,
    Autocomplete,
    ModalTemplate,
  },
  computed: {
    users() {
      const { userList } = this.$store.state.user;
      if (userList && userList.list.length) {
        return userList.list;
      }
      return [];
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'getStaffList',
    ]),
    getListUser(name = '') {
      const params = {
        skip: 0,
        take: 10,
        search: name,
      };
      this.getStaffList(params);
    },
    onInput(name) {
      clearTimeout(this.searchTimeoutId);
      this.searchTimeoutId = setTimeout(() => {
        this.getListUser(name);
      }, 500);
    },
    setUser(user) {
      this.model.assign_to = user.id;
    },
    showText(item) {
      return `${item.name} <strong class="document">${item.email}</strong>`;
    },
    send() {
      QuotationService.assingQuotation(this.quotation.id, this.model)
        .then(() => {
          this.model = { ...MODEL };
          this.setToggle({ type: 'assign_quotation_modal', bool: false });
          Events.$emit('update:pagination', false);
        });
    },
  },
  mounted() {
    Events.$on(_OPEN_ASSIGN_MODAL_, quotation => {
      this.quotation = quotation;
    });
  },
};
</script>

<style lang="scss" scoped>
.modal-content__control {
  display: flex;
  justify-content: flex-end;
}
</style>
